import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 385.05 205.29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M254.44 116.65c-20.5-3.79-22.94-27.8-43.59-32.67L70.98 51.54C30.27 42.09 21.74 29.72 0 0l187.78 52.53c22.44 6.28 24.63 31.78 46.76 36.95l60.53 14.04c13.6 3.16 20.66 13.19 31.08 26.5-23.91-4.46-47.8-8.95-71.72-13.37m130.62 88.64h-62.73c-23.74 0-18.74-19.78-37.95-20.74l-120.09-5.54c-30.61-1.52-38.15-6.49-56.38-31.43l160.28 14.78c18.83 1.84 17.95 22.28 36.59 23.14 33.01 1.52 29.53 1.38 56.37 2.63 11.68.55 17.09 8.42 23.91 17.16m-134.42-66.87-129.12-17.87c-35.07-5.08-42.2-12.07-62.66-40.07l172.77 31.95c19.86 3.72 21.22 26.3 40.96 29.03 36.57 5.06 27.24 3.78 58.13 8.06 10.95 1.52 16.03 6.82 27.27 21.19-22.9-2.13-45.8-4.28-68.7-6.39-19.03-1.76-19.53-23.19-38.65-25.89",
      style: {"fill":"#007dc5"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "EL-logo"}) } }